import { gql } from '@apollo/client'; 

export const USER_LOGIN = gql`mutation AeCheckUserLogin($username: String!, $password: String!) {
    aeCheckUserLogin(username: $username, password: $password)
}`;

export const USER_VERIFY = gql`mutation AeCheckUserVerify($token: String!) {
    verifyAECheckUserLogin(token: $token)
}`;

export const UPDATE_DATA_CHANNEL_CHECK = gql`
mutation ProcessEndpointName(
    $data: AECheckDataSourceInput!
) {
    processEndpointName(
        data: $data
    )
}`;